import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppInfo } from "../../../helpers/hooks/common-hook";
import PageContainerV2 from "../../../components/page-container/page-container-v2";

import WebChatAppeareance from "./web-chat-appeareance";
import WebChatPreview from "./web-chat-preview";
import WebChatInstall from "./web-chat-install";
import { defaultSettings } from "./web-chat-settings";

export const WEB_CHANNEL_NAVIGATION = [
  { name: "Settings", href: "/channels/web/settings" },
  { name: "Install", href: "/channels/web/install" },
];

/** `/channels` and `/channels/web` open the Web Chat settings tab. */
export function WebChannelRedirect() {
  const { pathname } = useLocation();
  const base = pathname.replace(/\/channels(\/web)?\/?$/, "");
  return <Navigate replace to={`${base}/channels/web/settings`} />;
}

function WebChatSettings() {
  const { appId } = useAppInfo();
  const [settings, setSettings] = useState(defaultSettings);
  return (
    // On wide screens the page is pinned to the channels area (which is
    // position: relative), so nothing inside can make an ancestor scroll: the
    // preview stays put and only the settings column scrolls. overflow-clip
    // (unlike hidden) can't be scrolled by focus or scrollIntoView either.
    // Stacked (narrow) layouts scroll as one page.
    <div className="mx-auto flex w-full max-w-[1600px] flex-col px-4 pt-6 sm:px-6 lg:px-8 xl:absolute xl:inset-0 xl:overflow-clip">
      <div className="grid min-w-0 grid-cols-1 items-start gap-8 pb-6 xl:min-h-0 xl:flex-1 xl:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)] xl:grid-rows-[minmax(0,1fr)] xl:items-stretch">
        <div className="min-w-0 xl:-mr-3 xl:min-h-0 xl:overflow-y-auto xl:pr-3">
          <WebChatAppeareance key={appId} onSettingsChange={setSettings} />
        </div>
        <div className="min-w-0 xl:min-h-0 xl:overflow-y-auto">
          <WebChatPreview key={appId} appId={appId} settings={settings} />
        </div>
      </div>
    </div>
  );
}

export default function IntegrationWebchatPage({ section = "settings" }) {
  return (
    <PageContainerV2 title="Web Chat" pageType="channels" pageSidebar={true} navigation={WEB_CHANNEL_NAVIGATION}
      subtitle="Embed and customize the chat widget on your website">
      {section === "install" ? <WebChatInstall /> : <WebChatSettings />}
    </PageContainerV2>
  );
}
